import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { togglePossessionArrowTeamOne, togglePossessionArrowTeamTwo } from '../../redux/reducers/playersReducer';
import PropTypes from 'prop-types';

const ReboundSelections = ({
  handleReboundPart,
  teamReboundSections,
  actionPlayerId,
  miss1PTActive,
  hideBlock,
  starState,
  scoreTemporaryData,
  teamOneId,
  teamTwoId,
  sendTimerData,
  game_log,
  setStarState,
  star_logo,
  setHideBlock
}) => {
  const dispatch = useDispatch();
  const {

    possessionArrowTeamOne,
    possessionArrowTeamTwo
  } = useSelector((state) => state?.playersReducer);
  const pointType = ['pointMiss1', 'pointMiss2', 'pointMiss3']
  const lastLog = game_log[0];

  const lastTeamId = lastLog?.t_id;

  const handlePassionArrowForOthers = () => {
    const t_id = scoreTemporaryData[0]?.t_id;
    const point_type = scoreTemporaryData[0]?.score_type;
    if (t_id == teamOneId && pointType.includes(point_type)) {
      if (lastTeamId == teamOneId) {
        if (possessionArrowTeamOne) {

          dispatch(togglePossessionArrowTeamTwo(true));
        } else {

          dispatch(togglePossessionArrowTeamOne(false));
        }
      } else {

        dispatch(togglePossessionArrowTeamTwo(true));
      }
      setTimeout(() => {
        sendTimerData();
      }, 100);
    } else if (t_id == teamTwoId && pointType.includes(point_type)) {
      if (lastTeamId == teamTwoId) {
        if (possessionArrowTeamTwo) {

          dispatch(togglePossessionArrowTeamOne(true));
        } else {

          dispatch(togglePossessionArrowTeamTwo(false));
        }


      } else {

        dispatch(togglePossessionArrowTeamOne(true));
      }
      setTimeout(() => {
        sendTimerData();
      }, 100);
    }
  }
  return (
    <div className="xxl:max-w-[570px] xxl:min-w-[570px] max-w-[244px] lg:max-w-[596px]  w-full  p-2 lg:p-6 pr-0 lg:pr-0 flex flex-col gap-[10px] lg:gap-[23px]">
      <div className="flex gap-[6px] md:gap-[10px] lg:gap-[23px] justify-end">
        <button
          onClick={() => {
            handleReboundPart("Others", actionPlayerId);
            handlePassionArrowForOthers();
            setHideBlock(false);
          }}
          className={`max-w-[72px] lg:max-w-[175px] lg:min-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[20px] lg:text-[48px] text-center
                ${teamReboundSections == "Others"
              ? "bg-[#419066] text-light"
              : "text-[#C08C5E]"
            } cursor-pointer`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          Others
        </button>

        {miss1PTActive === false && !hideBlock && (
          <button
            onClick={() => handleReboundPart("Block")}
            className={`max-w-[72px] lg:min-w-[175px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[20px] lg:text-[48px] text-center
                    cursor-pointer ${teamReboundSections == "Block"
                ? "bg-[#419066] text-light"
                : "text-[#C08C5E]"
              }`}
            style={{
              boxShadow:
                "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
            }}
          >
            Block
          </button>
        )}

        <button
          onClick={() => handleReboundPart("Rebound")}
          className={`max-w-[72px] lg:min-w-[175px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[20px] lg:text-[48px] text-center
              cursor-pointer ${teamReboundSections == "Rebound"
              ? "bg-[#419066] text-light"
              : "text-[#C08C5E]"
            }`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          Rebound
        </button>
      </div>
      <div className="flex gap-[6px] md:gap-[10px] lg:gap-[23px] justify-end">
        <div className="max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center"></div>
        <div className="max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center"></div>
        <div className="max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center"></div>
      </div>
      <div className="flex gap-[6px] md:gap-[10px] lg:gap-[23px] justify-end">
        <div className="max-w-[72px] md:max-w-[175px] relative  w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg text-[#D54043] leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center">
          <div
            className="max-w-[59.28px] lg:max-w-[140px] w-full lg:h-[140px] h-[59.28px] rounded-full text-[#D54043] leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center"
            style={{
              boxShadow:
                "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
            }}
          >
            {starState && (
              <button
                onClick={() => setStarState(!starState)}
                className="absolute max-w-[53.35px] lg:max-w-[126px] cursor-pointer w-full lg:h-[126px] h-[53.35px]  bg-gray-300 bg-opacity-80 rounded-full"
              ></button>
            )}
            <button
              onClick={() => setStarState(!starState)}
              className="max-w-[53.35px] lg:max-w-[126px] cursor-pointer  w-full lg:h-[126px] h-[53.35px] rounded-full"
              style={{
                padding: 0,
                border: 'none',
                background: 'none',
              }}
            >
              <img
                className="w-full h-full rounded-full"
                src={star_logo}
                alt="Star Logo"
              />
            </button>
          </div>
        </div>
        <div className="max-w-[175px]  w-full h-[262px]"></div>
        <div className="max-w-[175px]  w-full h-[262px]"></div>
      </div>
    </div>
  );
};

ReboundSelections.propTypes = {
  handleReboundPart: PropTypes.func.isRequired,
  teamReboundSections: PropTypes.string.isRequired,
  actionPlayerId: PropTypes.number.isRequired,
  miss1PTActive: PropTypes.bool.isRequired,
  starState: PropTypes.bool.isRequired,
  hideBlock: PropTypes.bool.isRequired,
  setStarState: PropTypes.func.isRequired,
  star_logo: PropTypes.string.isRequired,
  scoreTemporaryData: PropTypes.arrayOf(
    PropTypes.shape({
      t_id: PropTypes.number.isRequired,
      score_type: PropTypes.string.isRequired,
    })
  ).isRequired,
  teamOneId: PropTypes.number.isRequired,
  teamTwoId: PropTypes.number.isRequired,
  sendTimerData: PropTypes.func.isRequired,
  game_log: PropTypes.array.isRequired
};

export default ReboundSelections;